













































import Vue from "vue";
import Component from "vue-class-component";
import PageTitle from "@/components/atoms/PageTitle.vue";
import AlertMessage from "@/components/atoms/AlertMessage.vue";
import { IAlertInfo, ITableOptions } from "@/types";
import { HistoriesStore, EmployeesStore, LoginUserStore } from "../store";
import _ from "lodash";
import * as CONSTANTS from "@/common/constants";
import Utils from "@/common/utils";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const VueTabulator = require("vue-tabulator");
const Tabulator = VueTabulator.TabulatorComponent;

interface ITableSyncHistories {
  sync_histories_id: number;
  sync_start_date_time: string;
  status: number;
  company_name: string;
  sync_target_num: number;
  message: string | null;
  _children?: ITableSyncHistoriesDetail[];
}

interface ITableSyncHistoriesDetail {
  sync_histories_details_id: number;
  sync_start_date_time: string;
  status: number;
  company_name: string;
  sync_target_num: number;
  message: string | null;
}

@Component({
  components: { PageTitle, Tabulator, AlertMessage },
})
export default class SyncHistoriesList extends Vue {
  name: "SyncHistoriesList";
  private successAlertList: IAlertInfo[] = [];
  private dangerAlertList: IAlertInfo[] = [];
  private syncHistoriesTableList: ITableSyncHistories[] = [];

  created() {
    try {
      this.fetchHistories();
    } catch (errorInfos) {
      console.error(errorInfos);
      if (errorInfos) {
        this.clearAlertList();
        if (Array.isArray(errorInfos)) {
          errorInfos.forEach((error: any) => {
            if (error.item && error.message) {
              this.dangerAlertList.push({
                item: error.item,
                message: error.message,
              });
            }
          });
        }
      }
      if (this.dangerAlertList.length == 0) {
        this.dangerAlertList.push(Utils.getCommonAlertInfo());
      }
    }
  }

  get refs(): any {
    return this.$refs;
  }

  get title(): string {
    return "同期履歴一覧";
  }

  get tableOptions(): ITableOptions {
    return {
      layout: "fitDataStretch",
      pagination: "local",
      paginationSize: 30,
      dataTree: true,
      dataTreeStartExpanded: false,
      columns: [
        {
          title: "データ同期開始日時",
          field: "sync_start_date_time",
          sorter: "string",
          width: 250,
          formatter: (cell: any): string => {
            const sync_start_date_time: string = cell.getValue();
            if (_.isString(sync_start_date_time)) {
              const year: string = sync_start_date_time.substr(0, 4);
              const month: string = sync_start_date_time.substr(4, 2);
              const day: string = sync_start_date_time.substr(6, 2);
              const hour: string = sync_start_date_time.substr(8, 2);
              const minutes: string = sync_start_date_time.substr(10, 2);
              return `${year}/${month}/${day} ${hour}:${minutes}`;
            }
            return "";
          },
        },
        {
          title: "ステータス",
          field: "status",
          sorter: "number",
          width: 200,
          formatter: (cell: any, params: any): string => {
            const status: string = cell.getValue();
            if (status !== null) {
              return params.statusList[status];
            }
            return "";
          },
          formatterParams: { statusList: CONSTANTS.SYNC_HISTORIES_STATUS_LIST },
        },
        {
          title: "病院名",
          field: "company_name",
          sorter: "string",
          width: 300,
        },
        {
          title: "データ同期人数",
          field: "sync_target_num",
          sorter: "number",
          width: 200,
        },
        {
          title: "メッセージ",
          field: "message",
          sorter: "string",
          minWidth: 600,
        },
      ],
    };
  }

  private async fetchHistories() {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      await HistoriesStore.fetchHistories(LoginUserStore.getLoginUser.user_id);
      this.setSyncHistoriesTableList();
    } catch (errorInfos) {
      console.error(errorInfos);
      if (errorInfos) {
        if (Array.isArray(errorInfos)) {
          errorInfos.forEach((error: any) => {
            if (error.item && error.message) {
              this.dangerAlertList.push({
                item: error.item,
                message: error.message,
              });
            }
          });
        }
      }
      if (this.dangerAlertList.length == 0) {
        this.dangerAlertList.push(Utils.getCommonAlertInfo());
      }
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  private setSyncHistoriesTableList(): void {
    let syncHistoriesList: ITableSyncHistories[] = [];
    const histories = HistoriesStore.getHistories;
    for (let history of histories) {
      const childrenList: ITableSyncHistoriesDetail[] = [];
      for (let detail of history.sync_histories_details) {
        childrenList.push({
          sync_histories_details_id: detail.sync_histories_details_id,
          sync_start_date_time: detail.sync_start_date_time,
          status: detail.status,
          company_name: detail.company_name,
          sync_target_num: detail.sync_target_num,
          message: detail.message,
        });
      }
      syncHistoriesList.push({
        sync_histories_id: history.sync_histories_id,
        sync_start_date_time: history.sync_start_date_time,
        status: history.status,
        company_name: history.company_name,
        sync_target_num: history.sync_target_num,
        message: history.message,
        _children: childrenList,
      });
    }
    this.syncHistoriesTableList = syncHistoriesList;
  }

  private async onClickSyncHistoriesAllCompanies() {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      await EmployeesStore.syncEmployees(
        this.$store.state.LoginUser.loginUser.user_id
      );
      this.successAlertList = [
        {
          item: "SUCCESS001",
          message:
            "同期を開始しました。しばらく経ってから更新ボタンを押下し、結果を確認してください。",
        },
      ];
    } catch (errorInfos) {
      console.error(errorInfos);
      if (errorInfos) {
        this.clearAlertList();
        if (Array.isArray(errorInfos)) {
          errorInfos.forEach((error: any) => {
            if (error.item && error.message) {
              this.dangerAlertList.push({
                item: error.item,
                message: error.message,
              });
            }
          });
        }
      }
      if (this.dangerAlertList.length == 0) {
        this.dangerAlertList.push(Utils.getCommonAlertInfo());
      }
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  private clearAlertList(): void {
    this.successAlertList = [];
    this.dangerAlertList = [];
  }

  private onClickUpdateSyncHistories(): void {
    this.fetchHistories();
  }
}
